<template>
<div :class="is_nested ? '' : 'flex-table'">
    <div class="flex-table--row disable_line px-0 people-list--title">
        {{ operativeCountString }}
    </div>

    <list-item
        v-for="item in data"
        :key="item.id"
        :active="!getSignature(item).user.deleted_at || !inline_signature"
        @click="showUser(getSignature(item).user)"
    >
        <template
            slot="leading"
            v-if="!inline_signature"
        >
            <submission-signature-button
                :signature="getSignature(item)"
                @open-signature="openSignature(getSignature(item), getSignature(item).user)"
            />
        </template>
        <template slot="title">
            <div class="flex-table--row mx-0 px-0">
                <div class="form-submission-card--group">
                    <div class="people-list--item-title-name">{{ getSignature(item).user.full_name }}</div>
                    <div class="people-list--item-title-email">{{ getSignature(item).user.email }}</div>
                </div>
            </div>
        </template>
        <template
            slot="trailing"
            v-if="inline_signature"
        >
            <submission-inline-signature :signature="getSignature(item)" />
        </template>
    </list-item>
    <show-signature-modal
        :signature="selected_signature"
        :user="selected_user"
        ref="signature_modal"
    />
</div>
</template>

<script>
import ShowSignatureModal from "../modals/ShowSignatureModal";
import ListItem from "../ListComponent/ListItem";
import SubmissionSignatureButton from "../submissions/SubmissionSignatureButton";
import SubmissionInlineSignature from "../submissions/SubmissionInlineSignature";
import generateRoute from "../../helpers/routes";

export default {
    components: {
        ListItem,
        ShowSignatureModal,
        SubmissionSignatureButton,
        SubmissionInlineSignature,
    },
    props: {
        data: {
            type: Array,
            required: true
        },
        inline_signature: {
            type: Boolean,
            default: false
        },
        show_url: {
            type: String,
            required: true
        },
        is_nested: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            selected_signature: null,
            selected_user: null
        }
    },
    methods: {
        openSignature(signature, user) {
            this.selected_signature = signature;
            this.selected_user = user;
            this.$refs.signature_modal.open();
        },
        getSignature(item) {
            return item.signature ?? item;
        },
        showUser(user) {
            window.location.href = generateRoute(this.show_url, user.id);
        },
    },
    computed: {
        operativeCountString() {
            const dataLength = this.data.length;
            return (dataLength === 1 ? `${dataLength} person was` : `${dataLength} people were`) + ' included in this form';
        }
    }
}
</script>
